import React, { Component } from "react";
import { Grid, Header, Button, Image, Transition } from 'semantic-ui-react';

import twitterLogo from "../../../semantic/dist/themes/fibrestream/assets/images/twitter_logo.svg";
import instagramLogo from "../../../semantic/dist/themes/fibrestream/assets/images/instagram_logo.svg";
import { connect } from "react-redux";
import { AVAILABLE_PREWIRED, AVAILABLE_NOT_PREWIRED } from "../../../data/status";
import { googleTracking } from "../../../util";

class Step6 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation
    };
    this.transitionBack = this.transitionBack.bind(this);
  }

  componentDidMount() {
  const {status} = this.props;

  this.setState({
      visible: true
  });

  if(status === AVAILABLE_PREWIRED)
  {
    googleTracking({'event': 'virtualPageview', 'pageview': '/prewired/step8/stay-connected'});
  }
  else if(status === AVAILABLE_NOT_PREWIRED)
  {
    googleTracking({'event': 'virtualPageview', 'pageview': '/not-prewired/step8/stay-connected'});
  }
  else
  {
    googleTracking({'event': 'virtualPageview', 'pageview': '/unavailable&compatible/step5/thanks'});
  }
}

transitionBack()
 {
  const {  changeStep, result_type } = this.props;

  this.setState({
    animation: "fade left",
    visible: false
  });
  setTimeout(() => {    
    changeStep( this.getBackStep(result_type) , "fade right")
  }, 400);
 }

 getBackStep(result_type)
 {
   switch(result_type)
   {
     case 2: return 5;
     case null: 
     case 3: return 7;
     default: return 1;
   }
 }



  render() {
    const { visible, animation } = this.state;
    const {status, otherTimeSlot} = this.props;

    return <div>
      { this.props.backButton !== false && 
        <div className="back--icon" onClick={this.transitionBack}></div>
      }
      <Transition visible={visible} duration={500} animation={animation}>
        <div>
          <Header className='title__main' as='h1' textAlign='center'>
            <HeaderText status={status} otherTimeSlot={otherTimeSlot}/>
          </Header>
          <Header.Subheader className='text-black'>
            <SubHeaderText status={status} otherTimeSlot={otherTimeSlot} />
          </Header.Subheader>

          <Grid className='form__signup width__xs'>
            <Grid.Row className="py-0">
              <Grid.Column className="px-0">
                <div className='social-login'>
                    <a href="https://twitter.com/fibrestream" target="_blank" rel="noopener noreferrer" className="text-white">
                      <Button className='text-uc btn--full' size='medium' color='twitter'>
                        <Image src={twitterLogo}  verticalAlign='bottom'/>
                        <span>Follow Us On  Twitter</span>
                      </Button>
                    </a>

                    <a href="https://www.instagram.com/fibrestream" target="_blank" rel="noopener noreferrer" className="text-white">
                      <Button className='text-uc btn--full bg--instagram mt-12' size='medium'>
                        <Image src={instagramLogo}  verticalAlign='bottom'/>
                        <span>Follow Us On Instagram</span>
                      </Button>
                    </a>

                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Transition>
    </div>
  };
}

const HeaderText = (props) => {
  const {status} = props;
  if(status === AVAILABLE_PREWIRED || status === AVAILABLE_NOT_PREWIRED)
  {
    return "Stay Connected";
  }

  return 'Thanks';
}

const SubHeaderText = (props) => {
  
  const {status} = props;

  if(status === AVAILABLE_PREWIRED || status === AVAILABLE_NOT_PREWIRED)
  {
    return 'Follow us on social media for latest news and updates.';
  }
  return 'We’ll be in touch as soon as service is available in your building. In the meantime, follow us on social media for latest updates.';
}

const mapStateToProps = (state) => {
  return {
    result_type: state.connection.result_type,
    status: state.connection.status,
    otherTimeSlot: state.form.otherTimeSlot
  }
}

export default connect(mapStateToProps)(Step6);


// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/Step6.js